import { useMutation, useQuery } from '@tanstack/react-query';
import { cacheMutations, cacheQueries } from './cache.queries';

const REFRESH_MS = 15_000;

export function useCacheEntries() {
  return useQuery({ ...cacheQueries.entries(), refetchInterval: REFRESH_MS });
}

export function useCacheStats() {
  return useQuery({ ...cacheQueries.stats(), refetchInterval: REFRESH_MS });
}

export function useCacheEnabled() {
  return useQuery({ ...cacheQueries.enabled(), refetchInterval: REFRESH_MS });
}

export function useSetCacheEnabled() {
  return useMutation(cacheMutations.setEnabled());
}

export function useClearCache() {
  return useMutation(cacheMutations.clear());
}

export function useResetCacheStats() {
  return useMutation(cacheMutations.resetStats());
}
